import { SignupService } from './service/signup.service';
import { Component, OnInit } from '@angular/core';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {

  signupForm: FormGroup;
  isSignupError = false;
  signupErrorMessage: string;

  constructor(private fb: FormBuilder,
              private signupService: SignupService,
              private router: Router,
              private activeRoute: ActivatedRoute,
              private spinnerService: NgxSpinnerService) { }

  ngOnInit() {
    let subscriptionFrom = this.activeRoute.snapshot.params.id;
    this.buildForm(subscriptionFrom);
  }

  buildForm(subscriptionFrom) {

    this.signupForm = this.fb.group({
      contactName: ['', Validators.required],
        'contactEmail': ['', [
          Validators.required,
          Validators.email
        ]
      ],
      clientName: ['', Validators.required],
      contactPhone: ['', Validators.required],
      acceptTermsAndPrivacy: [false, Validators.required],
      recaptcha: false,
      subscriptionFrom: subscriptionFrom
    });

  }

  sumbitSignup() {

    console.log(this.signupForm.value);

    let signupFormData = this.signupForm.value;

    this.spinnerService.show();

     this.signupService.signup(signupFormData).subscribe(response => {
        let status = response.status;
        console.log(response);
        if (status === '100' || status === 100) {
            this.isSignupError =  true;
            this.spinnerService.hide();
            this.router.navigate(['signup-success', signupFormData.contactEmail]);
        } else {
            this.isSignupError =  false;
            this.signupErrorMessage = response.message;
            this.spinnerService.hide();
        }
    },
      err => {
        console.log(err);
           this.isSignupError =  true;
           this.signupErrorMessage = err.errorMessage;
           this.spinnerService.hide();
    });

  }

  onScriptLoad() {
        //console.log('Google reCAPTCHA loaded and is ready for use!')
  }

  onScriptError() {
       // console.log('Something went long when loading the Google reCAPTCHA')
  }

}



// WEBPACK FOOTER //
// ./src/app/signup/signup.component.ts